define('shoptheme/components/cart/ajax',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware/components/Dispatcher",
	"gigaset/spinner",
	"gigaset/fx-engine",
	"json!shoptheme/handles/default.json",
	"json!gigaset_recurring/handles/gigaset_recurring.json",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup",
	"bootstrap-button"
], function(
	$,
	_,
	Component,
	BEM,
	ComponentDispatcher,
	Spinner,
	FX,
	Handles,
	GigasetRecurringHandles,
	PopupHtml
) {
	var popupTemplate = null;

	return Component.create({
		miniCart:		null,
		$init: function() {
			var self = this,
				$body = $(document.body);

			this.miniCart = BEM.block("mini-cart");

			this._prepareForm();

			// Bind add to cart buttons / links
			$body.on("click", "[data-ajax-add-to-cart]", _.bind(function(e) {
				e.preventDefault();
				var link = $(e.currentTarget),
					url = link.attr("href") || link.data("add-to-cart-url"),
					container = link.closest(".b_product-item__container"),
					data = link.data("ajax-add-to-cart"),
					hasRequiredOptions = _.get(data, "hasRequiredOptions");

				if (hasRequiredOptions && $body.hasClass("catalog-product-view")) {
					return true;
				}

				e.preventDefault();

				Spinner.add(container.length == 0 ? 'body' : container);
				self._sendRequest(url, { "isAjax": 1, "qty": link.data("order-qty") }, self._onAddSuccess);
				$.magnificPopup.close();
			}, this));

			// Bind cart move to wishlist links
			$body.on("click", ".cart-table .move-to-wishlist", _.bind(function(e) {
				e.preventDefault();
				var link = $(e.currentTarget),
					url = link.attr("href");

				Spinner.add("#shopping-cart-table");

				self._sendRequest(url, { "isAjax": 1 });

			}, this));

			// Bind cart view qty selects
			$body.on("change", ".cart-table select.qty", function(e) {
				var form = $(".cart > form"),
					select = $(e.target),
					url = form.attr("action"),
					data = form.serialize() + '&content=cart',
					xhr = self._sendRequest(url, data, self._onUpdateSuccess);

				Spinner.add("#shopping-cart-table");

				xhr.then(function(response) {
					if (_.isObject(response)) {
						if (response.error) {
							select.val(select.data("__original_value"));

							if (select.data("select2")) {
								select.trigger("change.select2");
							}
						}
					}
					self._rememberCartQty();
				});
			});

			// Bind cart view remove links
			$body.on("click", ".cart-table a.remove-from-cart", function(e) {
				e.preventDefault();
				var url = $(e.currentTarget).attr("href"),
					data = $('.cart input[name="form_key"]').serialize() + '&content=cart';

				Spinner.add("#shopping-cart-table");
				e.preventDefault();
				self._sendRequest(url, data, self._onRemoveSuccess);
			});

			this._rememberCartQty();
		},

		_rememberCartQty: function() {
			$(".cart-table select.qty").each(function() {
				var select = $(this);

				select.data("__original_value", select.val());
			});
		},

		/**
		 * Overwrite productAddToCartForm submit function
		 * @private
		 */
		_prepareForm: function() {
			if ($('body').hasClass('wishlist-index-configure') !== true) { // quick fix to prevent ajax add2cart on wishlist configure product view page
				var self = this,
					formObj = _.get(window, "productAddToCartFormOld", _.get(window, "productAddToCartForm"));

				if (!formObj) return;

				formObj.submit = function () {
					if (this.validator.validate()) {
						var form = $(this.form),
							url = form.attr("action");

						Spinner.add();
						self._sendRequest(url, form.serialize(), self._onAddSuccess);
					}
				};
			}
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		/**
		 * Send ajax request
		 *
		 * @param url
		 * @param data
		 * @param onSuccessCallback
		 * @private
		 */
		_sendRequest: function(url, data, onSuccessCallback) {
			var self = this;

			data = data || {};

			// add isAjax param to avoid caching problems
			if (url.indexOf("isAjax=1") === -1 && typeof data === 'string' && data.indexOf("isAjax=1") === -1) {
				url += url.indexOf("?") === -1 ? '?isAjax=1' : '&isAjax=1';
			}

			var xhr = $.ajax(url, {
				method: "POST",
				data: data
			}).always(function() {
				Spinner.remove();
			}).then(_.bind(function(response, status, xhr) {
				var responseHandles = $.parseJSON(xhr.getResponseHeader("X-Magento-Handles") || "[]");

				var _isResponseHtml = (typeof response === 'string');
				response = _isResponseHtml ? { body: response } : response;

				if (response.redirect) {
					window.location = response.redirect;
					return;
				}

				if (response.success === true && typeof onSuccessCallback === 'function') {
					onSuccessCallback(response);
				}
				if (response.mini_cart) {
					self.miniCart.replaceWith(response.mini_cart);
					self.miniCart = BEM.block("mini-cart");
				}
				if (response.cart) {
					FX.transitionBlend(".cart", response.cart, 300);
				}
				if (response.body || response.message) {
					$.magnificPopup.open({
						items: {
							src: this._renderPopup({
								body: response.body ? response.body : response.message
							}),
							type: 'inline'
						},
						callbacks: {
							open: function () {
								if (_isResponseHtml === true) {
									new ComponentDispatcher({
										handles: _.intersection(["catalog_product_view", "PRODUCT_TYPE_configurable", "PRODUCT_TYPE_gigaset_recurring_plan_config"], responseHandles),
										apply: _.assign({}, Handles, GigasetRecurringHandles)
									});

									$(document).trigger("cartware_cart/modal/open", [response]);

									self._prepareForm();
								}

								$(document.body).scrollTop($(".mfp-content").offset().top - 60);
							}
						}
					});

					if ($.magnificPopup.instance.isOpen) {
						$(document.body).scrollTop($(".mfp-content").offset().top - 60);
					}
				}

				return response;
			}, this));

			return xhr;
		},
		_onAddSuccess: function(response) {
			$(document).trigger("cartware_cart/add", response);
		},
		_onRemoveSuccess: function(response) {
			$(document).trigger("cartware_cart/remove", response);
		},
		_onUpdateSuccess: function(response) {
			$(document).trigger("cartware_cart/update", response);
		}
	});
});
